import { SessionStorageItems } from "services/user/user.session.service";
import { setItemStorage } from "services/util/sessionStorage.service";
import { ICustomerFullName, IUserInfoData } from "./PrivateHome.model";

const _capitalizeFirstLetter = (item: string) => {
  return item ? item.charAt(0).toUpperCase() + item.slice(1) : null;
};

const _checkIsEmpty = (item: string | null) => {
  return !!item ? item : "";
};

const _getFullNameCapilizate = (customerFullName: ICustomerFullName) => {
  const name = _capitalizeFirstLetter(customerFullName?.name);
  const firstSurname = _capitalizeFirstLetter(customerFullName?.firstSurname);
  const secondSurname = _capitalizeFirstLetter(customerFullName?.secondSurname);

  return `${_checkIsEmpty(name)} ${_checkIsEmpty(firstSurname)} ${_checkIsEmpty(
    secondSurname
  )}`;
};

/**
 * @description function that returns PMyProfile literals
 * @param userInfo
 * @returns
 */
export const mapPMyProfile = (userInfo: IUserInfoData, t: any) => {
  saveSessionUser(userInfo);
  const fullName = _getFullNameCapilizate(userInfo?.customerFullName);
  const cardsLinksSection = [
    {
      hrefLink: "/my-preferences",
      disabled: false,
      cardText: t("mapPMyProfile.userSection.literals.preferences"),
      iconType: "filter",
    },
    // {
    //   hrefLink: "/cards-titles",
    //   disabled: false,
    //   cardText: t("mapPMyProfile.userSection.literals.paymentMethods"),
    //   iconType: "pay",
    // },
    // {
    //   hrefLink: "/my-points",
    //   disabled: false,
    //   cardText: t("mapPMyProfile.userSection.literals.myPoints"),
    //   iconType: "fidelizacion",
    // },
    // {
    //   hrefLink: "/my-documents",
    //   disabled: false,
    //   cardText: t("mapPMyProfile.userSection.literals.myDocuments"),
    //   iconType: "upLoadDocumentMeridas",
    // },
     {
      hrefLink: "/permissions",
      disabled: false,
      cardText: t("mapPMyProfile.userSection.literals.permissions"),
      iconType: "security",
    },


    
  ];
  return {
    title: t("mapPMyProfile.title"),
    subtitle: t("mapPMyProfile.subtitle"),
    userSection: {
      fullName,
      email: userInfo?.email,
      imageSrc: userInfo?.profileImage,
      imageAlt: fullName +t("mapPMyProfile.userSection.imageAlt"),
      literals: {
        logoutButtonText: t(
          "mapPMyProfile.userSection.literals.logoutButtonText"
        ),
        editLink: {
          text: t("mapPMyProfile.userSection.literals.editLink.text"),
          href:  t("mapPMyProfile.userSection.literals.editLink.href"),
        },
      },
    },
    cardsLinksSection,
  };
};

/**
 * Method to save userdata for informational web.
 * @param userInfo
 */
export const saveSessionUser = (userInfo: IUserInfoData) => {
  const user = { name: userInfo?.customerFullName.name };
  setItemStorage(SessionStorageItems.RAAS_USER, user);
};
